import { cn } from "frontend-components/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="skeleton"
            className={cn("animate-pulse rounded-card bg-muted", className)}
            {...props}
        />
    );
}

export { Skeleton };
